import { SET_LOCALE } from "common/store/reducers/language";

export const setLocale = (locale: string) => ({
  type: SET_LOCALE,
  payload: locale,
});
